const isEnabled = (key, featureFlags) => {
  // If feature flags don't exist within the object or the feature flag object is null
  // we are considering the flag disabled.
  if (!featureFlags || !Object.prototype.hasOwnProperty.call(featureFlags, key))
    return false

  return !!featureFlags[key]
}

/**
 * --- WARNING! ---
 * @deprecated This file facilitates an outdated feature flag implementation and will be removed.
 */

/**
 * Generates a series of feature toggle functions that will instruct which features
 * are enabled or not
 * @param {Object} featureFlags Dictionary of feature flags
 */
export const createFeatureDecisions = (featureFlags) => {
  return {
    selfService: {
      /**
       * Displays the V2 booking cards.
       *
       * This feature flag is temporary and should be removed as soon as the Booking Card V2 design
       * has been approved for wide spread use.
       * @see [TASK 108](https://dev.azure.com/anzukeducation/Staffroom%20NEXT/_workitems/edit/108) - Booking Card V2
       * @returns true: displays v2 booking card. false: displays v1 booking card
       */
      showBookingCardV2: isEnabled(
        'r2B_SelfService_ShowBookingCardV2',
        featureFlags
      ),
      /**
       * Enables the extend booking functionality
       *
       * @see [FEATURE 10](https://dev.azure.com/anzukeducation/Staffroom%20NEXT/_workitems/edit/10) - Extend booking
       * @returns true: displays extend booking CTA. false: hides extend booking CTA.
       */
      enableExtendBooking: isEnabled(
        'r2B_SelfService_EnableExtendBooking',
        featureFlags
      ),
      /**
       * Enables the ability to duplicate a booking
       *
       * @see [STORY 3314](https://dev.azure.com/anzukeducation/Staffroom%20NEXT/_workitems/edit/3314)
       * @returns true: displays duplicate booking actions. false: hides duplicate booking actions, disables duplicate booking route.
       */
      enableDuplicateBooking: isEnabled(
        'r2B_SelfService_EnableDuplicateBooking',
        featureFlags
      ),
      /**
       * Enables the ability to edit a booking
       *
       * @see [STORY 3314](https://dev.azure.com/anzukeducation/Staffroom%20NEXT/_workitems/edit/3314)
       * @returns true: displays edit booking actions. false: hides edit booking actions, disables edit booking route.
       */
      enableEditBooking: isEnabled(
        'r2B_SelfService_EnableEditBooking',
        featureFlags
      ),
      /**
       * Enables the booking list view
       *
       * @see [STORY 3314](https://dev.azure.com/anzukeducation/Staffroom%20NEXT/_workitems/edit/3314)
       * @returns true: enables the booking list view and nav item. false: hides booking list nav item, disables booking list route.
       */
      enableBookingList: isEnabled(
        'r2B_Web_SelfService_EnableBookingList',
        featureFlags
      ),
      /**
       * Enables the export bookings functionality
       *
       * @see [STORY 3314](https://dev.azure.com/anzukeducation/Staffroom%20NEXT/_workitems/edit/3314)
       * @returns true: enables the export booking button and modal. false: hides the export booking button.
       */
      enableBookingExport: isEnabled(
        'r2B_Web_SelfService_EnableBookingExport',
        featureFlags
      ),
    },
  }
}
